import { initAppInsights } from "./appInsights";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";

initAppInsights();

createRoot(document.getElementById("root")).render(<App />);
